import { styled } from '@mui/material/styles';
const Input = styled('input')({});
export default Input;
//# sourceMappingURL=Input.js.map